// extracted by mini-css-extract-plugin
module.exports = {"benefit":"WorkoutBenefit_benefit__RWQ2U","benefitSvg":"WorkoutBenefit_benefitSvg__COE7d","benefitText":"WorkoutBenefit_benefitText__3s9FC"};